import { render, staticRenderFns } from "./header.vue?vue&type=template&id=f5ac776c&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=f5ac776c&prod&lang=less"
import style1 from "./header.vue?vue&type=style&index=1&id=f5ac776c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ac776c",
  null
  
)

export default component.exports